import { Observable, of, ReplaySubject } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiRoutes } from "../../../config/api-routes";
import { catchError } from "rxjs/internal/operators";
import { InterventionTeam } from "../model/interventionTeam";

@Injectable()
export class InterventionTeamService {
  public selectedInterventionTeam: ReplaySubject<InterventionTeam>;

  constructor(private httpClient: HttpClient, private apiRoutes: ApiRoutes) {
    this.selectedInterventionTeam = new ReplaySubject();
  }

  public getTeams(): Observable<InterventionTeam[]> {
    return this.httpClient.get<InterventionTeam[]>(this.apiRoutes.GET_INTERVENTION_TEAMS).pipe(
      catchError(error => {
        return of([] as any);
      })
    );
  }

  public getTeamsForBuilding(buildingId: string): Observable<InterventionTeam[]>{
    return this.httpClient.get<InterventionTeam[]>(
      this.apiRoutes.getRouteWithInjectedParams(
        this.apiRoutes.GET_BUILDING_INTERVENTIONTEAMS,
        [buildingId])).pipe(
      catchError(error => {
        return of([] as any);
      })
    );
  }

  public setTeam = (team: InterventionTeam) => {
    this.selectedInterventionTeam.next(team);
  };
}
